import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../../@commons/ui-components/shared.module";
import { ArticleListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/article/article-list.response';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { VwDatePipe } from '../../pipes/vw-date.pipe';
import { articleDisplayTitle, articleTagKeys } from './article-display';

@Component({
    selector: 'vw-article',
    imports: [
        SharedModule,
        CommonModule,
        TranslatePipe,
        VwDatePipe
    ],
    templateUrl: './article.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './article.component.scss'
})
export class ArticleComponent {
  @Input() article: ArticleListResponse;
  /**
   * Format carte, pour une grille de deux par rangée.
   *
   * La bannière pleine largeur est juste pour une liste d'articles ; sur
   * l'accueil, elle prenait la hauteur de trois blocs utiles.
   */
  @Input() compact = false;
  constructor(private router: Router) { }

  /** Titre sans l'emoji de tête (B6). */
  get title(): string {
    return articleDisplayTitle(this.article?.title);
  }

  /** Étiquettes connues seulement, traduites (B6). */
  get tagKeys(): string[] {
    return articleTagKeys(this.article?.tags);
  }

  onArticleClicked(articleUid: number) {
    this.router.navigate(['/article', articleUid]);
  }
}
